import { clone } from "ramda";

import { fileNameComparator, fileTypeComparator } from "@/modules/files/utils/utils.ts";
import type { ITableColumn } from "@/redux/modules/table-data.ts";
import { CELL_TYPE, SORT_ORDER_ASC, SORT_ORDER_DESC } from "@/settings/settings.ts";

export const fileBrowserGridColumnDefs: Partial<ITableColumn>[] = [
  {
    name: "Name",
    field: "file",
    cellType: CELL_TYPE.FILENAME,
    sortable: true,
    sort: { direction: SORT_ORDER_ASC.toLowerCase(), priority: null },
    comparator: fileNameComparator(CELL_TYPE.FILENAME),
    filterValueGetter: "file.fileName",
    fixed: true,
  },
  {
    name: "Date Modified",
    field: "file.lastModified",
    cellType: CELL_TYPE.DATE_TIME,
    sortable: true,
    sortingOrder: ["desc", "asc", ""],
    comparator: fileTypeComparator(CELL_TYPE.DATE_TIME),
  },
  {
    name: "Owner",
    field: "file.creator.display",
    cellType: CELL_TYPE.STRING,
    sortable: true,
    comparator: fileTypeComparator(CELL_TYPE.STRING),
  },
  {
    name: "Size",
    field: "file.size",
    cellType: CELL_TYPE.INTEGER,
    sortable: true,
    comparator: fileTypeComparator(CELL_TYPE.INTEGER),
  },
  {
    name: "Description",
    field: "file.description",
    cellType: CELL_TYPE.STRING,
    sortable: true,
    comparator: fileTypeComparator(CELL_TYPE.STRING),
  },
  {
    name: "Organisms",
    field: "file.organisms.name",
    groupField: "file.organisms",
    cellType: CELL_TYPE.STRING_LIST,
    sortable: true,
    comparator: fileTypeComparator(CELL_TYPE.STRING_LIST),
  },
  {
    name: "Samples",
    field: "file.samples.name",
    groupField: "file.samples",
    cellType: CELL_TYPE.STRING_LIST,
    sortable: true,
    comparator: fileTypeComparator(CELL_TYPE.STRING_LIST),
  },
  {
    name: "Parents",
    field: "file.parents.name",
    groupField: "file.parents",
    cellType: CELL_TYPE.STRING_LIST,
    sortable: true,
    comparator: fileTypeComparator(CELL_TYPE.STRING_LIST),
  },
];

export const fileSearchGridColumnDefs: Partial<ITableColumn>[] = clone(fileBrowserGridColumnDefs);
fileSearchGridColumnDefs.splice(1, 0, {
  name: "Path",
  field: "file.path",
  cellType: CELL_TYPE.STRING,
  sortable: false,
  comparator: fileTypeComparator(CELL_TYPE.STRING),
});
fileSearchGridColumnDefs.splice(2, 0, {
  name: "Project",
  field: "file.project.name",
  groupField: "file.project",
  cellType: CELL_TYPE.STRING,
  sortable: true,
  comparator: fileTypeComparator(CELL_TYPE.STRING),
});

fileSearchGridColumnDefs[0].sort = undefined;
fileSearchGridColumnDefs[3].sort = { direction: SORT_ORDER_DESC.toLowerCase(), priority: 1 };
